import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IdentityService } from '../../api/services/identity.service';
import { ToastService } from '../../services/toast.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  standalone: false,
})
export class ResetPasswordComponent {
  /**
   * The code used to reset the users password, which comes from the query params of the reset password link sent
   * to the user
   */
  resetCode: string | undefined;

  /**
   * Form to reset password
   */
  resetPasswordForm = new FormGroup({
    newPassword: new FormControl<string>('', Validators.required),
    confirmPassword: new FormControl<string>('', Validators.required),
  });

  constructor(
    private route: ActivatedRoute,
    private identityService: IdentityService,
    private toastService: ToastService,
    private router: Router,
  ) {
    this.route.queryParams.pipe(takeUntilDestroyed()).subscribe((params) => {
      this.resetCode = params['code'];

      if (!this.resetCode) {
        void this.router.navigate(['error/not-found']);
      }
    });
  }

  /**
   * Resets the users password using the code and new password, then redirects to the login page
   */
  resetPassword() {
    this.identityService
      .resetPasswordPost$Response({
        body: {
          code: this.resetCode!,
          newPassword: this.resetPasswordForm.controls.newPassword.value!,
        },
      })
      .subscribe({
        next: () => {
          this.toastService.success('Reset Password Success');
          void this.router.navigate(['/']);
        },
        error: () => {
          this.toastService.error(
            'The password reset link is invalid or has expired. Please initiate a new password reset ' +
              'request to continue',
          );
        },
      });
  }

  /**
   * Whether the new and confirmation passwords match
   */
  passwordsMatch() {
    return (
      this.resetPasswordForm.controls.newPassword.value! &&
      this.resetPasswordForm.controls.confirmPassword.value! &&
      this.resetPasswordForm.controls.newPassword.value ===
        this.resetPasswordForm.controls.confirmPassword.value
    );
  }
}
